import { createAction } from 'store/utils';
import {
  DeleteMappingFailureAction,
  DeleteMappingRequestAction,
  DeleteMappingSuccessAction,
  FetchAddReturnDataFailureAction,
  FetchAddReturnDataPostSuccessAction,
  FetchAddReturnDataPreSuccessAction,
  FetchAddReturnDataRatesSuccessAction,
  FetchAddReturnDataRequestAction,
  ResetReturnDataAction,
  SaveMappingFailureAction,
  SaveMappingRequestAction,
  SaveMappingSuccessAction,
  FetchReturnTypesRequestAction,
  FetchReturnTypesSuccessAction,
  FetchReturnTypesFailureAction,
  FetchDefaultTaxRatesRequestAction,
  FetchDefaultTaxRatesSuccessAction,
  FetchDefaultTaxRatesFailureAction,
} from './types';
import {
  DELETE_MAPPING_FAILURE,
  DELETE_MAPPING_REQUEST,
  DELETE_MAPPING_SUCCESS,
  FETCH_ADD_RETURN_DATA_FAILURE,
  FETCH_ADD_RETURN_DATA_POST_SUCCESS,
  FETCH_ADD_RETURN_DATA_PRE_SUCCESS,
  FETCH_ADD_RETURN_DATA_RATES_SUCCESS,
  FETCH_ADD_RETURN_DATA_REQUEST,
  RESET_RETURN_DATA,
  SAVE_MAPPING_FAILURE,
  SAVE_MAPPING_REQUEST,
  SAVE_MAPPING_SUCCESS,
  FETCH_RETURN_TYPES_REQUEST,
  FETCH_RETURN_TYPES_SUCCESS,
  FETCH_RETURN_TYPES_FAILURE,
  FETCH_DEFAULT_TAX_RATES_REQUEST,
  FETCH_DEFAULT_TAX_RATES_SUCCESS,
  FETCH_DEFAULT_TAX_RATES_FAILURE,
  MAP_TAX_RATES_TO_BOXES,
  MAP_TAX_RATES_TO_BOXES_FAILURE,
  RESET_AI_MAPPING_STATUS,
  SET_TAX_RATES_TO_BOXES_MAPPING,
} from './constants';

import {
  ReturnData,
  ReturnFrequencies,
  ReturnType,
  Section,
  TaxRate,
  ReturnTypesData,
} from './models/returnData';
import { MappingData, DefaultTaxRatesData } from './models';

// Fetch Reports
export const fetchAddReturnDataRequest = (
  connectionId: string,
  loadedReturnData?: ReturnData,
  returnTypeId?: string
): FetchAddReturnDataRequestAction =>
  createAction(FETCH_ADD_RETURN_DATA_REQUEST, {
    connectionId,
    loadedReturnData,
    returnTypeId,
  });

export const fetchAddReturnDataPreSuccess = (
  returnTypes?: ReturnType[],
  returnTypesEdit?: ReturnType[],
  returnFrequency?: ReturnFrequencies,
  connectionId?: string
): FetchAddReturnDataPreSuccessAction =>
  createAction(FETCH_ADD_RETURN_DATA_PRE_SUCCESS, {
    returnTypes,
    returnTypesEdit,
    returnFrequency,
    connectionId,
  });

export const fetchAddReturnDataRatesSuccess = (
  taxRates: TaxRate[]
): FetchAddReturnDataRatesSuccessAction =>
  createAction(FETCH_ADD_RETURN_DATA_RATES_SUCCESS, {
    taxRates,
  });

export const fetchAddReturnDataPostSuccess = (
  sections: Section[],
  sectionsReturnTypeId?: string
): FetchAddReturnDataPostSuccessAction =>
  createAction(FETCH_ADD_RETURN_DATA_POST_SUCCESS, {
    sections,
    sectionsReturnTypeId,
  });

export const fetchAddReturnDataFailure = (): FetchAddReturnDataFailureAction =>
  createAction(FETCH_ADD_RETURN_DATA_FAILURE);

// Save Mapping
export const saveMappingRequest = (
  connectionId: string,
  mappingData: MappingData,
  organisationId: string,
  redirectOrganisationId?: string,
  stayOnPage = true
): SaveMappingRequestAction =>
  createAction(SAVE_MAPPING_REQUEST, {
    connectionId,
    mappingData,
    organisationId,
    redirectOrganisationId,
    stayOnPage,
  });

export const saveMappingSuccess = (): SaveMappingSuccessAction =>
  createAction(SAVE_MAPPING_SUCCESS);

export const saveMappingFailure = (): SaveMappingFailureAction =>
  createAction(SAVE_MAPPING_FAILURE);

// Delete Mapping
export const deleteMappingRequest = (
  organisationId: string,
  mappingId: string
): DeleteMappingRequestAction =>
  createAction(DELETE_MAPPING_REQUEST, { organisationId, mappingId });

export const deleteMappingSuccess = (): DeleteMappingSuccessAction =>
  createAction(DELETE_MAPPING_SUCCESS);

export const deleteMappingFailure = (): DeleteMappingFailureAction =>
  createAction(DELETE_MAPPING_FAILURE);

// RESET
export const resetReturnData = (): ResetReturnDataAction =>
  createAction(RESET_RETURN_DATA);

// Fetch Return Types (new standalone flow)
export const fetchReturnTypesRequest = (
  connectionId: string
): FetchReturnTypesRequestAction =>
  createAction(FETCH_RETURN_TYPES_REQUEST, {
    connectionId,
  });

export const fetchReturnTypesSuccess = (
  returnTypesData: ReturnTypesData
): FetchReturnTypesSuccessAction =>
  createAction(FETCH_RETURN_TYPES_SUCCESS, {
    returnTypesData,
  });

export const fetchReturnTypesFailure = (): FetchReturnTypesFailureAction =>
  createAction(FETCH_RETURN_TYPES_FAILURE);

// Fetch Default Tax Rates (new standalone flow)
export const fetchDefaultTaxRatesRequest = (
  returnTypeId: string,
  connectionId: string
): FetchDefaultTaxRatesRequestAction =>
  createAction(FETCH_DEFAULT_TAX_RATES_REQUEST, {
    returnTypeId,
    connectionId,
  });

export const fetchDefaultTaxRatesSuccess = (
  defaultTaxRatesData: DefaultTaxRatesData
): FetchDefaultTaxRatesSuccessAction =>
  createAction(FETCH_DEFAULT_TAX_RATES_SUCCESS, {
    defaultTaxRatesData,
  });

export const fetchDefaultTaxRatesFailure =
  (): FetchDefaultTaxRatesFailureAction =>
    createAction(FETCH_DEFAULT_TAX_RATES_FAILURE);

export const mapTaxRatesToBoxes = (orgUuid: string, returnTypeId?: string) =>
  createAction(MAP_TAX_RATES_TO_BOXES, { orgUuid, returnTypeId });

export const mapTaxRatesToBoxesFailure = () =>
  createAction(MAP_TAX_RATES_TO_BOXES_FAILURE);

export const resetAiMappingStatus = () =>
  createAction(RESET_AI_MAPPING_STATUS);

export const setTaxRatesToBoxesMapping = (mapping: any) =>
  createAction(SET_TAX_RATES_TO_BOXES_MAPPING, { mapping });